function refreshGallery(p){
	var $ = jQuery;

	var items = $('a[data-fancybox]',p).not('.external');

	items.each(function(){
		var c = $(this).parent().parent().parent();
		if(c.hasClass('flowy-hidden') || c.hasClass('flowy-clone'))
			items = items.not($(this));
	});
	
	items.unbind().fancybox({
		'speedIn'		:	300, 
		'speedOut'		:	300, 
		'overlayShow'	:	true,
		'centerOnScroll'    : false,
		'cyclic'        : true,
		'autoScale'         : true,
		'overlayColor'      : '#3f3f3f',
		'overlayOpacity'    : 0.95,
		'onStart'	: function(){
			$('.mt-image-hover').stop().animate({opacity: 0},400);
		}
	});
}

function beforeGalleryChange(p){
	jQuery('>div>div a[data-fancybox]',p).unbind().click(function(){
		return false;
	});
}

jQuery(function($){
	var searchinput = $('nav .searchinput');

	searchinput.focus(function(){
		$(this).stop().animate({'width': '190px'});
	});
	searchinput.blur(function(){
		$(this).stop().animate({'width': '100px'});
	});
	
	$('.mt-nav-bar>ul>li').hoverIntent({
		over: function(){

			var nav,
                            li = $(this);
	
			if( $('ul.sub-menu li',li).length>0 && !$('ul.sub-menu',li).hasClass('mt-submenu-active') ){
				nav = li.parent().parent();
				$('.mt-submenu-active',nav).css({ 'z-index':9997}).removeClass('mt-submenu-active').stop();
				nav.stop().animate({'margin-bottom':$('body').hasClass('narrow') ? 35 : 45}, 300);
				
				$('>ul',li).addClass('mt-submenu-active').stop().css({display:'block', opacity:0, 'z-index':9998}).animate({opacity:1, height:35}, 300);
			} else if (!$('>ul', this).hasClass('mt-submenu-active')) {
				nav = li.parent().parent();
				nav.stop().animate({'margin-bottom': $('body').hasClass('narrow') ? 0 : 10}, 300);
				$('.mt-submenu-active',nav).css({ 'z-index':9997}).removeClass('mt-submenu-active').stop();
				
				$('>ul>li>ul',nav).animate({height:0, opacity: 0}, 300);
			}
		},
		out: function(){

		},
		timeout: 600
	});

	$('.mt-nav-bar>ul>li>ul').addClass('mt-dropdown');
	$('nav.mt-dropdown>ul, ul.mt-dropdown').superfish({
		animation:   {height:'show'},
		speed:       'slow',
		dropShadows: false
	});
	
	var lastElement = null;
	$('.mt-nav-bar>ul>li.current-menu-ancestor').last().each(function(){
			lastElement = $(this);
			var li = $(this);
			li.parent().parent().stop().animate({'margin-bottom':$('body').hasClass('narrow') ? 35 : 45}, 300);
			$('>ul',li).addClass('mt-submenu-active').stop().css({display:'block', opacity:0, 'z-index':9998}).animate({opacity:1, height:35}, 300);
	});

	$(".mt-image-effect-default a,.mt-image-no-effect a").not('.external').fancybox({
		'speedIn'		:	300, 
		'speedOut'		:	300, 
		'overlayShow'	:	true,
		'centerOnScroll'    : false,
		'cyclic'        : true,
		'autoScale'         : true,
		'overlayColor'      : '#3f3f3f',
		'overlayOpacity'    : 0.95,
		'onStart'	: function(){
			$('.mt-image-hover').stop().animate({opacity: 0},400);
		}
	});

	$('.mt-image-effect-default').each(function(){
		var enter = 0;
		$(this).mouseenter(function(){
			enter = 1;
			$('.mt-image-hover',$(this)).stop().animate({opacity: 0.8},400);
			$('.mt-image-hover-icon',$(this)).stop().animate({opacity: 1, top:0},800,'easeOutExpo');
			$('.mt-image-hover-title', $(this)).stop().doTimeout(150, function(){
				if(enter)
					$(this).stop().animate({opacity: 1.0, bottom:0},400,'easeOutExpo');
				else
					$(this).stop().animate({opacity: 0,bottom:'-50%'},800,'easeOutSine');
					
			});
		}).mouseleave(function(){
			enter = 0;
			$('.mt-image-hover',this).stop().animate({opacity: 0},400);
			$('.mt-image-hover-icon',this).stop().animate({opacity: 0, top:'-50%'},800,'easeOutExpo');
			$('.mt-image-hover-title', $(this)).stop().animate({opacity: 0,bottom:'-50%'},800,'easeOutSine');
		});
	});
	

	

	/* Main scroll to top */
	$('.mt-scrolltotop-main').off('click').on('click', function(){
		$('html, body').stop().animate({'scrollTop': 0}, 600);
		return false;
	});

		
	var scrollAnimated = false;
	var visible = false;
	$('.mt-scrolltotop-main').css({opacity:0});
	$(window).scroll(function(){
		if(scrollAnimated) return false;
		
		if($(window).scrollTop()>200 && !visible) {
			scrollAnimated = true;
			$('.mt-scrolltotop-main').animate({opacity:1}, 200, function(){scrollAnimated = false; visible = true; });
		}
		else if( visible && $(window).scrollTop()<200) {
			scrollAnimated = true;
			$('.mt-scrolltotop-main').animate({opacity:0}, 200, function(){scrollAnimated = false; visible = false; });
		}
	});
	
	/* CONTACT FORM */
	$('form.mt-contact input, form.mt-contact textarea').each(function(){
		$(this).focus(function(){
			if(this.value === this.defaultValue)
				$(this).val('');
		});

		$(this).blur(function(){
			if(this.value === '')
				$(this).val(this.defaultValue);
		});

	});
	
	$('form.mt-contact a').click(function(){
		var $form = $(this).parent().parent().parent();
		var valid = true;

		$('input, textarea', $form).each(function(){
			var $$ = $(this);

			if($$.hasClass('required') && (!$$.val() || this.value == this.defaultValue)) {
				$('#'+$$.attr('id')+'-error').parent().fadeIn();
				valid = false;
			} else {
				$('#'+$$.attr('id')+'-error').parent().hide();
				if($$.hasClass('email')){
					if(!/^((([a-z]|\d|[!#\$%&'\*\+\-\/=\?\^_`{\|}~]|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])+(\.([a-z]|\d|[!#\$%&'\*\+\-\/=\?\^_`{\|}~]|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])+)*)|((\x22)((((\x20|\x09)*(\x0d\x0a))?(\x20|\x09)+)?(([\x01-\x08\x0b\x0c\x0e-\x1f\x7f]|\x21|[\x23-\x5b]|[\x5d-\x7e]|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])|(\\([\x01-\x09\x0b\x0c\x0d-\x7f]|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF]))))*(((\x20|\x09)*(\x0d\x0a))?(\x20|\x09)+)?(\x22)))@((([a-z]|\d|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])|(([a-z]|\d|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])([a-z]|\d|-|\.|_|~|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])*([a-z]|\d|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])))\.)+(([a-z]|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])|(([a-z]|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])([a-z]|\d|-|\.|_|~|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])*([a-z]|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])))\.?$/i.test($$.val()))
					{
						$('#'+$$.attr('id')+'-error-email').parent().fadeIn();
						valid = false;
					}
					else
						$('#'+$$.attr('id')+'-error-email').parent().hide();
				}
			}
		});

		if(valid){

			$.post(
				$form.attr('action'), {
					action: 'mt-contact-ajax',
					name: $('#mt-contact-name').val(),
					email: $('#mt-contact-email').val(),
					message: $('#mt-contact-message').val(),
					subject: $('#mt-contact-subject').val(),
					nonce: $('#mt-contact-nonce').val()
				},
				function(response) {
					var classes = 'mt-box ' + (response.type == 'error' ? 'mt-box-error' : 'mt-box-info');
					var msg = $('<div></div>').addClass(classes).append($('<h3></h3>').html(response.title)).append($('<p></p>').html(response.message)).hide().fadeIn(1800);
					$form.html('').append(msg);
				},
				'text json'
				);
		}
		return false;
	});

	$('.mt-arrow-link').hover(function(){
		$(this).stop().animate({right:15});
	},function(){
		$(this).stop().animate({right:20});
	});

	$('.mt-socials a, .lang-item a img').tipTip({edgeOffset:15});
	$('.mt-arrow-link').tipTip({defaultPosition: 'left', edgeOffset:5});
	
	$('footer .mt-socials a').tipTip({defaultPosition: 'top'});
	$('.searchinput').tipTip({defaultPosition: 'top', activation: 'click'});
	
	$('.mt-responsive-menu select').change(function(){
		if ($(this).val() !== '#') {
			window.location.href = $(this).val();
		}
	});
	

});
